import * as FieldTypes from 'forms-utils-lib/fieldTypes/FormFieldTypes';
import createDependentFormField from '../formField/utils/createDependentFormField';
import DependentFieldKeys from 'forms-utils-lib/constants/formField/DependentFieldKeys';
export const DependentFieldPanelType = {
  NEW: 'NEW',
  EDIT: 'EDIT'
};
export const DependentFieldFilterKeys = {
  STRING_VALUE: 'strValue',
  STRING_VALUES: 'strValues',
  NUMBER_VALUE: 'numberValue',
  NUMBER_VALUES: 'numberValues',
  BOOL_VALUE: 'boolValue',
  OPERATOR: 'operator'
};
export const DependentFieldOperator = {
  EQ: 'EQ',
  NEQ: 'NEQ',
  CONTAINS: 'CONTAINS',
  DOESNT_CONTAIN: 'DOESNT_CONTAIN',
  STR_STARTS_WITH: 'STR_STARTS_WITH',
  STR_ENDS_WITH: 'STR_ENDS_WITH',
  LT: 'LT',
  LTE: 'LTE',
  GT: 'GT',
  GTE: 'GTE',
  BETWEEN: 'BETWEEN',
  NOT_BETWEEN: 'NOT_BETWEEN',
  WITHIN_TIME: 'WITHIN_TIME',
  WITHIN_TIME_REVERSE: 'WITHIN_TIME_REVERSE',
  SET_ANY: 'SET_ANY',
  SET_NOT_ANY: 'SET_NOT_ANY',
  SET_ALL: 'SET_ALL',
  SET_NOT_ALL: 'SET_NOT_ALL',
  SET_EQ: 'SET_EQ',
  SET_NEQ: 'SET_NEQ',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY'
};
export const getOperatorTranslation = operator => {
  const translations = {
    EQ: 'dependentFields.operators.EQ',
    NEQ: 'dependentFields.operators.NEQ',
    CONTAINS: 'dependentFields.operators.CONTAINS',
    DOESNT_CONTAIN: 'dependentFields.operators.DOESNT_CONTAIN',
    STR_STARTS_WITH: 'dependentFields.operators.STR_STARTS_WITH',
    STR_ENDS_WITH: 'dependentFields.operators.STR_ENDS_WITH',
    LT: 'dependentFields.operators.LT',
    LTE: 'dependentFields.operators.LTE',
    GT: 'dependentFields.operators.GT',
    GTE: 'dependentFields.operators.GTE',
    BETWEEN: 'dependentFields.operators.BETWEEN',
    NOT_BETWEEN: 'dependentFields.operators.NOT_BETWEEN',
    WITHIN_TIME: 'dependentFields.operators.WITHIN_TIME',
    WITHIN_TIME_REVERSE: 'dependentFields.operators.WITHIN_TIME_REVERSE',
    SET_ANY: 'dependentFields.operators.SET_ANY',
    SET_NOT_ANY: 'dependentFields.operators.SET_NOT_ANY',
    SET_ALL: 'dependentFields.operators.SET_ALL',
    SET_NOT_ALL: 'dependentFields.operators.SET_NOT_ALL',
    SET_EQ: 'dependentFields.operators.SET_EQ',
    SET_NEQ: 'dependentFields.operators.SET_NEQ',
    IS_NOT_EMPTY: 'dependentFields.operators.IS_NOT_EMPTY'
  };
  return translations[operator];
};
export const DependentFieldOperatorsByFieldType = {
  [FieldTypes.TEXT]: [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.CONTAINS, DependentFieldOperator.DOESNT_CONTAIN, DependentFieldOperator.STR_STARTS_WITH, DependentFieldOperator.STR_ENDS_WITH, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.PHONE_NUMBER]: [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.CONTAINS, DependentFieldOperator.DOESNT_CONTAIN, DependentFieldOperator.STR_STARTS_WITH, DependentFieldOperator.STR_ENDS_WITH, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.TEXTAREA]: [DependentFieldOperator.CONTAINS, DependentFieldOperator.DOESNT_CONTAIN, DependentFieldOperator.STR_STARTS_WITH, DependentFieldOperator.STR_ENDS_WITH, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.RADIO]: [DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.SELECT]: [DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.CHECKBOX]: [DependentFieldOperator.SET_EQ, DependentFieldOperator.SET_NEQ, DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.SET_ALL, DependentFieldOperator.SET_NOT_ALL, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.SINGLE_CHECKBOX]: [DependentFieldOperator.EQ, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.DATE]: [DependentFieldOperator.EQ, DependentFieldOperator.LT, DependentFieldOperator.GT, DependentFieldOperator.BETWEEN, DependentFieldOperator.NOT_BETWEEN, DependentFieldOperator.WITHIN_TIME_REVERSE, DependentFieldOperator.WITHIN_TIME, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.NUMBER]: [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.LT, DependentFieldOperator.LTE, DependentFieldOperator.GT, DependentFieldOperator.GTE, DependentFieldOperator.BETWEEN, DependentFieldOperator.NOT_BETWEEN, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.FILE]: [DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.STAR_RATING]: [DependentFieldOperator.SET_EQ, DependentFieldOperator.SET_NEQ, DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.SET_ALL, DependentFieldOperator.SET_NOT_ALL, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.NUMBER_RATING]: [DependentFieldOperator.SET_EQ, DependentFieldOperator.SET_NEQ, DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.SET_ALL, DependentFieldOperator.SET_NOT_ALL, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.NPS]: [DependentFieldOperator.EQ, DependentFieldOperator.NEQ, DependentFieldOperator.LT, DependentFieldOperator.LTE, DependentFieldOperator.GT, DependentFieldOperator.GTE, DependentFieldOperator.BETWEEN, DependentFieldOperator.NOT_BETWEEN, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.CSAT]: [DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.IS_NOT_EMPTY],
  [FieldTypes.SMILEY_RATING]: [DependentFieldOperator.SET_ANY, DependentFieldOperator.SET_NOT_ANY, DependentFieldOperator.IS_NOT_EMPTY]
};
export const DependentFieldValidationType = {
  OPERATOR_REQUIRED: 'OPERATOR_REQUIRED',
  VALUE_REQUIRED: 'VALUE_REQUIRED',
  FIELD_REQUIRED: 'FIELD_REQUIRED'
};
export const DefaultFilter = {
  [DependentFieldFilterKeys.STRING_VALUE]: '',
  [DependentFieldFilterKeys.NUMBER_VALUE]: 0,
  [DependentFieldFilterKeys.BOOL_VALUE]: false,
  [DependentFieldFilterKeys.NUMBER_VALUES]: [],
  [DependentFieldFilterKeys.STRING_VALUES]: [],
  [DependentFieldFilterKeys.OPERATOR]: DependentFieldOperator.EQ
};
export const DefaultDependentField = {
  [DependentFieldKeys.FORM_FIELD_ACTION]: 'DISPLAY',
  [DependentFieldKeys.DEPENDENT_FORM_FIELD]: createDependentFormField({}),
  [DependentFieldKeys.FILTERS]: [DefaultFilter] // createDependentFieldFilter
};